import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { ServiceTemplateForm } from '@models/forms/service-template-form';
import { forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ServiceTemplateFormService {
  constructor(private http: HttpClient) {}

  getServiceForms(clinicServiceTemplateId: number) {
    return this.http.get<ServiceTemplateForm[]>(
      environment.baseUrl + 'api/ServiceTemplateForms/' + clinicServiceTemplateId
    );
  }

  assignFormToService(serviceForm: ServiceTemplateForm) {
    return this.http.post<ServiceTemplateForm>(environment.baseUrl + 'api/ServiceTemplateForms', serviceForm);
  }

  assignFormsToService(serviceForms: ServiceTemplateForm[]) {
    return forkJoin(
      serviceForms.map((sf) =>
        this.http.post<ServiceTemplateForm>(environment.baseUrl + 'api/ServiceTemplateForms', sf)
      )
    );
  }

  updatedServiceForms(serviceForms: ServiceTemplateForm[]) {
    return forkJoin(
      serviceForms.map((sf) => this.http.put<ServiceTemplateForm>(environment.baseUrl + 'api/ServiceTemplateForms', sf))
    );
  }

  deleteServiceForm(serviceFormId: number) {
    return this.http.delete(environment.baseUrl + 'api/ServiceTemplateForms/' + serviceFormId);
  }

  deleteServiceForms(serviceForms: ServiceTemplateForm[]) {
    return forkJoin(
      serviceForms.map((sf) =>
        this.http.delete(
          environment.baseUrl + 'api/ServiceTemplateForms/' + sf.clinicServiceTemplateId + '/' + sf.clinicFormId
        )
      )
    );
  }
}
